import { RootState } from './reducers';

export const getModuleListQuery = (state: RootState): null | string => state.moduleList.query;
export const getModuleListFilterByProvider = (state: RootState): null | string => state.moduleList.provider;

export const getSiteTheme = (state: RootState): null | string => state.theme.theme;
